export const LAYOUT_1_0 = 'order';
export const LAYOUT_1_2 = 'order-wishlist-wishlist';
export const LAYOUT_2_0 = 'order-order';
export const LAYOUT_2_2 = 'order-order-wishlist-wishlist';
